import request from '@/utils/request'
const apiPath = '/cust/customerTagGroup'
const clientLabelApi = {
  /**
   * 新增修改【客户标签】
   */
  create(data) {
    return request.post(`${apiPath}/saveorupdate`, data)
  },
  create1(data) {
    return request.post(`${apiPath}`, data)
  },
  update1(data) {
    return request.put(`${apiPath}`, data)
  },
  /**
   * 分页查询【客户标签】
   */
  fetchList(query) {
    return request.get(`${apiPath}/customerGroupAndTagList`, { params: query })
  },
  fetchNewList(query) {
    return request.get(`${apiPath}`, { params: query })
  },
  /**
   * 批量删除【用户标签分组】
   */
  deleteBatch(ids) {
    return request.delete(`${apiPath}`, { data: ids })
  },
  /**
   * 选项列表【用户标签分组】
   */
  options() {
    return request.get(`${apiPath}/options`)
  }
}
export default clientLabelApi
